export default __webpack_public_path__ + "static/media/designs.24f5890d.svg";